<div class="row text-center justify-content-center">
  <div class="col-8 col-sm-6 col-md-4">
    <form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit()" class="w-100">
      <mat-selection-list class="w-100" formControlName="value">
        <mat-list-option *ngFor="let answer of answers$ | async" [value]="answer" checkboxPosition="before"
          class="w-100 my-1 text-left">
          <span>{{answer}}</span>
        </mat-list-option>
      </mat-selection-list>
    </form>
  </div>
</div>
